import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import iconSend from '../../../assets/images/icon-send.svg';
import { IsMobile } from '../../../helpers/IsMobile';
import ButtonWithIcon from '../ButtonWithIcon/ButtonWithIcon';

const SendReferralButton = ({ instantReferralLink }) => {
  const { t } = useTranslation('common');
  const mobile = IsMobile();
  const { pathname } = useLocation();

  const handleClick = () => {
    window.open(instantReferralLink, '_blank');
  };

  if (pathname.includes('/refer')) {
    return null;
  }

  return (
    <ButtonWithIcon
      img={iconSend}
      imgClassName="btn-icon-36"
      text={mobile ? '' : t('buttons.sendReferral')}
      textClassName={mobile ? '' : 'btn-icon-text-primary-40'}
      variant="primary-36"
      onClick={handleClick}
      data-testid="send-referral-button"
    />
  );
};

export default SendReferralButton;
